/**
 * @file automatically generated from MApp.Endpoints.Controllers.ActiveDirectoryController
 */ 

import { MetadataClient } from '../metadataClient';
import { IAzureMetadata, IOpenIdConnectMetadata, IActiveDirectoryInfo, ISaveTenant, IValidationResult } from '../models';
import { ActiveDirectoryType } from '../enums/';

export class ActiveDirectoryClient extends MetadataClient {

    public static getAzureMetadata(tenantName: string) {
        return MetadataClient.ajax<IAzureMetadata>(
            new Request(MetadataClient.endpointsUrl + `api/v1/activedirectory/${encodeURIComponent(tenantName)}/azureMetadata`),
			true
        );
    }

    public static getOpenIdConnectMetadata(tenantName: string) {
        return MetadataClient.ajax<IOpenIdConnectMetadata>(
            new Request(MetadataClient.endpointsUrl + `api/v1/activedirectory/${encodeURIComponent(tenantName)}/openidconnectMetadata`),
			true
        );
    }

    public static getActiveDirectoryType(tenantName: string) {
        return MetadataClient.ajax<ActiveDirectoryType>(
            new Request(MetadataClient.endpointsUrl + `api/v1/activedirectory/${encodeURIComponent(tenantName)}/type`),
			true
        );
    }

    public static getActiveDirectoryInfo(tenantName: string) {
        return MetadataClient.ajax<IActiveDirectoryInfo>(
            new Request(MetadataClient.endpointsUrl + `api/v1/activedirectory/${encodeURIComponent(tenantName)}/info`),
			true
        );
    }

    public static isActiveDirectoryValid(saveTenant: ISaveTenant) {
        return MetadataClient.ajax<IValidationResult>(
            new Request(MetadataClient.endpointsUrl + `api/v1/activedirectory/isValid`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(saveTenant)
			}),
			true
        );
    }
}
